import './sectionSocial.scss';

import ScrollMagic from 'scrollmagic';

export default (() => {
	$(document).ready(function () {
		if ($('.section--social').length > 0) {
			const controller = new ScrollMagic.Controller();
			// social animation
			const section = document.querySelector('.section--social');
			const items = section.querySelectorAll('.social__item');
			new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: '0.5'
			})
				.on('enter', e => {
					section.querySelector('.title').classList.add('title--completed');
					section.querySelector('.social__bg').classList.add('title--completed');
					let index = 0;
					Array.prototype.forEach.call(items, function (item) {
						$(item).css({
							animation: `fade-down .5s linear ${0.1 + index * 0.1}s forwards`
						});
						index++;
					});
				})
				.on('leave', e => {
					section.classList.remove('colored');
					section.querySelector('.title').classList.remove('title--completed');
					section.querySelector('.social__bg').classList.remove('title--completed');
					Array.prototype.forEach.call(items, function (item) {
						$(item).css({
							animation: ''
						});
					});
				})
				// .addIndicators()
				.addTo(controller);
			new ScrollMagic.Scene({
				triggerElement: section,
				triggerHook: '0.2'
			})
				.on('enter', e => {
					if ($('#careers').length > 0) {
						document.querySelector('.header__menu').classList.remove('header__menu--yellow');
						document.querySelector('.header__menu').classList.add('header__menu--white');
					}
				})
				.on('leave', e => {
					if ($('#careers').length > 0) {
						document.querySelector('.header__menu').classList.remove('header__menu--white');
						document.querySelector('.header__menu').classList.add('header__menu--yellow');
					}
				})
				// .addIndicators()
				.addTo(controller);
		}
	});
})();
